<template>
<div>
  <div v-if="isLoading">
    <LoadingSingle v-if="showSingleHeader" />
    <LoadingMulti v-else-if="showMultiHeader" />
    <Loading v-else />
  </div>
  <div v-else-if="isNoResult">
    <no-result @tryAgain="tryAgain" :noResult="noResult" />
  </div>
  <div v-else class="trending_list_page">
    <!-- 新版实验总榜-头部 -->
    <TrendHeaderCom
      :dataType="dataType"
      :header="header"
      :ruleMap="ruleMap"
      :rankType="rankType"
      :types="types"
    >
      <template #list="ctx">
        <!-- 榜单 品类-->
        <div :class="['type_container', types.length === 1 ? 'single' : '', { 'hide-type': ctx.hideType, 'new-header-style': newHeader }]">
          <type
            v-if="!ctx.hideType"
            :types="types"
            :subItems="subItems"
            :selectedType="rankType"
            :showMulti="showMultiHeader"
            @tapType="tapType"
          />
          <!-- 单榜-单品 -->
          <p 
            v-if="ctx.hideType && subItems.length===1"
            class="new-header-item-only"
          >{{subItems[0].title}}</p>
          <!-- 单品End -->
          <category
            v-if="subItems.length && !(types.length===1&&subItems.length===1)"
            @traceAllItems="traceAllItems"
            @tapCateId="tapCateId"
            @tapOccupy="tapOccupy"
            class="category_container"
            :occupySubItemOfAll="occupySubItemOfAll"
            :subItems="subItems"
            :selectedCateId="cateId"
          />
          <div :class="['feed_container_out', showTabBar ? 'min_height' : '', types.length === 1 ? 'short_types' : '']" ref="feedRef" id="feed">
            <loading 
              v-if="isLoadingFeed"
              :isLoadingFeed="isLoadingFeed"
              :newHeader="newHeader"
            />
            <no-result v-else-if="isNoResultFeed" :noResult="noResult" :isNoResultFeed="isNoResultFeed" />
            <feed
              ref="feedList"
               v-else
               :transformFeed="!showSingleHeader && types.length === 1 "
               :getObserverLogData="getObserverLogData"
               :feed="feed"
               :selectedType="rankType"
               :newHeader="newHeader"
               @traceShopCk="traceShopCk"
            />
          </div>
        </div>
      </template>
    </TrendHeaderCom>
    <!-- 吸顶 -->
    <div ref="tabBar" :class="['tab_bar', showTabBar ? '' : 'hidden']">
      <div class="tab_title">
        <!-- <svg @click="closePage" xmlns="http://www.w3.org/2000/svg" overflow="hidden" viewBox="0 0 48 48" style="width:1em;height:1em;vertical-align:middle"><path fill-rule="nonzero" d="M33.39 4.558a1.976 1.976 0 0 0-2.684-.063l-.124.119-15.196 15.918a5.026 5.026 0 0 0-.164 6.75l.163.18 15.197 15.924c.76.796 2.017.821 2.808.056.75-.725.811-1.9.17-2.698l-.114-.13L18.249 24.69a1.005 1.005 0 0 1-.078-1.293l.079-.093L33.446 7.386a2.01 2.01 0 0 0-.056-2.828z"/></svg> -->
        <!-- <div class="title">{{$t('FoodC_STORE_sDEb_djsn' /**trending food */)}}</div> -->
      </div>
      <!-- 榜单 -->
      <div v-if="types.length > 1" class="tab_type">
        <div v-for="(type, index) in types" :key="index" class="type_out_item" @click="tapType(type)">
          <div class="type_item">
            <div :class="['type_name', rankType === type.cateId ? 'selected':'']">{{type.title}}</div>
            <div v-if="rankType === type.cateId" class="type_bottom_line"></div>
          </div>
          <div v-if="index+1 < types.length" class="split"></div>
        </div>
      </div>
      <div v-else-if="subItems.length <= 1" class="tab_type_1"></div><!-- 单榜单单品类占位 -->
      <!-- 品类 -->
      <div v-if="!(types.length <= 1 && subItems.length <= 1)" class="tab_category">
        <category
        @tapCateId="tapCateId"
        @tapOccupy="tapOccupy"
        @traceAllItems="traceAllItems"
        class="category_container"
        :occupySubItemOfAll="occupySubItemOfAll"
        :subItems="subItems"
        :selectedCateId="cateId" />
      </div>
    </div>
    <div id="tab_bar" v-if="!showTabBar" :class="['rules', {'new-rules-style': newHeader}]" @click="showRules">
      <div class="name">{{$t('FoodC_shoprank_OYFZ_jaot' /** rules */)}}</div>
      <!-- <svg viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="outlined_pickup备份-2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><path d="M4.37546222,9 C5.97314311,9 7.2791231,10.24892 7.37036953,11.8237272 L7.37546222,12 L7.37546222,32 C7.37546222,32.5128358 7.76150241,32.9355072 8.2588411,32.9932723 L8.37546222,33 L28.3754622,33 C30.0323165,33 31.3754622,34.3431458 31.3754622,36 C31.3754622,37.5976809 30.1265423,38.9036609 28.551735,38.9949073 L28.3754622,39 L8.37546222,39 C4.5900105,39 1.50636354,35.9952166 1.37952124,32.2406498 L1.37546222,32 L1.37546222,12 C1.37546222,10.3431458 2.71860797,9 4.37546222,9 Z" id="路径-3" fill="#000000" fill-rule="nonzero" transform="translate(16.375462, 24.000000) rotate(-135.000000) translate(-16.375462, -24.000000) "></path></g></svg> -->
      <img class="rules_img" src="./img/outlined_pickup_right.png" />
    </div>
    <!-- <svg @click="closePage" class="back_icon" xmlns="http://www.w3.org/2000/svg" overflow="hidden" viewBox="0 0 48 48" style="width:1em;height:1em;vertical-align:middle"><path fill-rule="nonzero" d="M33.39 4.558a1.976 1.976 0 0 0-2.684-.063l-.124.119-15.196 15.918a5.026 5.026 0 0 0-.164 6.75l.163.18 15.197 15.924c.76.796 2.017.821 2.808.056.75-.725.811-1.9.17-2.698l-.114-.13L18.249 24.69a1.005 1.005 0 0 1-.078-1.293l.079-.093L33.446 7.386a2.01 2.01 0 0 0-.056-2.828z"/></svg> -->
    <!-- rules -->
    <rules v-if="isShowRules" :rules="rules" @clickMask="clickMask" />
  </div>
</div>
</template>
<script>
import Type from './type.vue'
import Category from './category.vue'
import Feed from './feed.vue'
import Rules from './rules.vue'
import Loading from './loading.vue'
import NoResult from './noResult.vue'
import TrendHeaderCom from './headerCom.vue'
import LoadingSingle from './loadingSingle.vue'
import LoadingMulti from './loadingMulti.vue'
import { SINGLE_RANK, MULTI_RANK } from './const.js'

import Api from "@/api";
import trackEvent from '@/common/js/track'
let feedInterval = null
export default {
  components: {
    Type,
    Category,
    Feed,
    Rules,
    Loading,
    LoadingSingle,
    LoadingMulti,
    NoResult,
    TrendHeaderCom
  },
  data() {
    return {
      isLoading: false,
      isLoadingFeed: false,
      isNoResult: false,
      isNoResultFeed: false,
      isShowRules: false,
      init: true,
      rankType: '1',
      cateId: '',
      fromChannel: 0, // 商卡1 榜单组件0
      homepage_absolute_position: 0, // 埋点需要
      dataType: '', // multiRank总榜 singleRank单榜
      showVersion: 0, // 样式标示：0，旧样式；1，新样式单榜单；2，新样式多榜单
      header: {},
      rules: [],
      types: [],
      subItems: [],
      feed: [],
      ruleMap: {},
      showTabBar: false,
      feedListTop: 0,
      occupySubItemOfAll: {},
      noResult: {
        title: '',
        subTitle: '',
      },
      traceId: '',
      stop: false,
      scrollHeight: 0,
      cateMap: {},
      recId: '',
    }
  },
  computed: {
    newHeader() {
      return !!this.dataType
    },
    showSingleHeader() {
      return this.dataType === SINGLE_RANK
    },
    showMultiHeader() {
      return this.dataType === MULTI_RANK
    },
  },
  async created() {
    this.isLoading = true;
    const { ranktype, cateid, fromchannel, showVersion, homepage_absolute_position } = this.$route.query;
    this.rankType = ranktype;
    this.cateId = cateid;
    this.fromChannel = fromchannel;
    this.homepage_absolute_position = homepage_absolute_position;
    this.showVersion = Number(showVersion)
    this.dataType = this.showVersion
      ? this.showVersion === 1 
        ? SINGLE_RANK
        : this.showVersion === 2
          ?  MULTI_RANK
          : ''
      : ''
    await this.rankIndex();
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
    if (feedInterval) {
      clearInterval(feedInterval);
    }
    const _this = this;
    feedInterval = setInterval(() => {
      if (_this.scrollHeight) {
        clearInterval(feedInterval);
      } else {
        _this.scrollHeight = this.$refs?.feedRef?.getBoundingClientRect()?.top - document?.getElementById('tab_bar')?.getBoundingClientRect()?.y;
        // alert(_this.scrollHeight);
      }
    }, 1000);
    setTimeout(() => {
      clearInterval(feedInterval);
    }, 4000)
  },
  methods: {
    getObserverLogData(shop, index) {
      var tags = [];
      shop.tags.forEach((tag) => {
        tags.push(tag.content || '');
      });
      return {
        eventId: 'sailing_c_x_homepage_realexposure_sw',
        eventLabel: '榜单落地页商卡曝光',
        attrs: {
          'trace_id': this.traceId || '',
          'shop_id': shop.shopId || '',
          'is_free_delivery_type': shop.freeDeliveryType || 0, // 1没有免配2券包免配3新客免配
          content_json: {
            'id': shop.shopId || '',
            'shop_name': shop.shopName || '',
            'status': shop.cShopStatus || '',
            'delivery_fee':
            shop.currency || ''
                + '_' + (shop.deliveryPriceOri || 0.0).toString()
                + '_' +  (shop.deliveryPriceAct || 0.0).toString(),
            'delivery_time': shop.deliveryTime || 0,
            'shop_discount_tag': tags.join(','),
            'page': 'trendingpage',
            'index': index || 0,
            'trending_type': this.rankType || '',
            'nlp_category_id': this.cateId || '',
            'module': 8888,
            'rec_id': this.recId,
            'is_free_delivery_type': shop.freeDeliveryType || 0, // 1没有免配2券包免配3新客免配
            'from_channel': this.fromChannel,
            'homepage_absolute_position': this.homepage_absolute_position,
          }
        }
      }
    },
    tracePageSw() {
      trackEvent({
        eventId: 'sailing_c_x_trending_page_sw',
        eventLabel: '榜单落地页页面曝光',
        attrs: {
          'module_list': this.types.map(t => t.cateId).join(','),
          'trace_id': this.traceId,
          'from_channel': this.fromChannel,
          'trending_type': this.rankType || '',
        }
      })
    },
    // 埋点-榜单曝光
    traceTypeSw(item, index) {
      trackEvent({
        eventId: 'sailing_c_x_trending_module_sw',
        eventLabel: 'trending落地页榜单类型展示',
        attrs: {
          'trace_id': this.traceId,
          'index': index || 0,
          'from_channel': this.fromChannel,
          'trending_type': +item.cateId || '',

        }
      })
    },
    // 埋点-榜单点击
    traceTypeCk(item) {
      trackEvent({
        eventId: 'sailing_c_x_trending_module_ck',
        eventLabel: 'trending落地页榜单类型点击',
        attrs: {
          'trace_id': this.traceId,
          'from_channel': this.fromChannel,
          'trending_type': +item.cateId || '',

        }
      })
    },
    traceCateIdCk(category, index) {
      trackEvent({
        eventId: 'sailing_c_x_trending_nlp_category_ck',
        eventLabel: '榜单落地页品类点击',
        attrs: {
          'nlp_category_id': category.cateId || '',
          'module_type': this.rankType || '',
          'index': index || 0,
          'trending_type': this.rankType || '',
          'from_channel': this.fromChannel,
        }
      })
    },
    traceCateIdSw(category, index) {
      const key = this.rankType + category.cateId;
      if (!this.cateMap[key]) {
        this.cateMap[key] = true;
        trackEvent({
          eventId: 'sailing_c_x_trending_nlp_category_sw',
          eventLabel: '榜单落地页品类曝光',
          attrs: {
            'nlp_category_id': category.cateId || '',
            'module_type': this.rankType || '',
            'index': index || 0,
            'trending_type': this.rankType || '',
            'from_channel': this.fromChannel,
          }
        })
      }
    },
    traceAllItems(allItems) {
      allItems.forEach(item => {
        this.traceCateIdSw(item, 0)
      });
    },
    traceShopCk(shop, index) {
      var tags = [];
      shop.tags.forEach((tag) => {
        tags.push(tag.content || '');
      });
      trackEvent({
        eventId: 'sailing_c_x_homepage_shop_ck',
        eventLabel: '榜单落地页商卡点击',
        attrs: {
          'trace_id': this.traceId || '',
          'shop_id': shop.shopId || '',
          'shop_name': shop.shopName || '',
          'shop_status': shop.cShopStatus || '',
          'shop_delivery_fee':
          shop.currency || ''
              + '_' + (shop.deliveryPriceOri || 0.0).toString()
              + '_' +  (shop.deliveryPriceAct || 0.0).toString(),
          'shop_delivery_time': shop.deliveryTime || 0,
          'shop_discount_tag': tags.join(','),
          'page': 'trendingpage',
          'index': index || 0,
          'trending_type': this.rankType || '',
          'nlp_category_id': this.cateId || '',
          'module': 'trending',
          'from_channel': this.fromChannel,
          'homepage_absolute_position': this.homepage_absolute_position,
        }
      })
    },
    traceShopSw(shop, index) {
      var tags = [];
      shop.tags.forEach((tag) => {
        tags.push(tag.content || '');
      });
      trackEvent({
        eventId: 'sailing_c_x_homepage_realexposure_sw',
        eventLabel: '榜单落地页商卡实时曝光',
        attrs: {
          'trace_id': this.traceId || '',
          'shop_id': shop.shopId || '',
          'shop_name': shop.shopName || '',
          'shop_status': shop.cShopStatus || '',
          'shop_delivery_fee':
          shop.currency || ''
              + '_' + (shop.deliveryPriceOri || 0.0).toString()
              + '_' +  (shop.deliveryPriceAct || 0.0).toString(),
          'shop_delivery_time': shop.deliveryTime || 0,
          'shop_discount_tag': tags.join(','),
          'page': 'trendingpage',
          'index': index || 0,
          'trending_type': this.rankType || '',
          'nlp_category_id': this.cateId || '',
        }
      })
    },
    closePage() {
      this.SodaBridge('closePage');
    },
    clickMask() {
      this.isShowRules = false;
    },
    showRules() {
      this.isShowRules = true;
    },
    async tryAgain() {
      this.isLoadingFeed = true;
      await this.rankIndex();
    },
    async tapCateId(category, index) {
      this.isLoadingFeed = true;
      this.occupySubItemOfAll = {};
      const cateId = category.cateId;
      this.cateId = cateId;
      await this.rankIndex(true);
      this.traceCateIdCk(category, index);
    },
    async tapOccupy(occupy) {
      this.isLoadingFeed = true;
      this.occupySubItemOfAll = {};
      this.cateId = occupy.cateId;
      await this.rankIndex();
      this.traceCateIdCk(occupy, 0);
    },
    async tapType(item) {
      // this.stop = true;
      this.isLoadingFeed = true;
      const type = item.cateId;
      this.rankType = type;
      await this.rankIndex();
      this.traceTypeCk(item);
      // window.location.href= '#feed'
      // document.getElementById("feed").scrollIntoView();
      // this.stop = false;
      // header头部的高度/feed离可视区 - 吸顶的高度
    },
    hiddenTab() {
      try {
        this.SodaBridge('updateNav', {
          // sysStatusBar: 0,
          backBtn: {
            alpha: 1,
            color: '#000000'
          },
          title: {
            color: '#000000',
            alpha: 0,
            content: '',
            position: 'center' //如果是tab进入，left，否则center，left “left/center”
          },
        })
      } catch(err) {}
    },
    showTab() {
      try {
        this.SodaBridge('updateNav', {
          // sysStatusBar: 0, // 0黑色,1白色
          backBtn: {
            alpha: 1, // 透明度
            color: '#000000' // 字体颜色
          },
          title: {
            color: '#000000',
            alpha: 1,
            content: this.$t('FoodC_STORE_sDEb_djsn' /**trending food */),
            position: 'center' //如果是tab进入，left，否则center，left “left/center”
          },
        })
      } catch(err) {}
    },
    onScroll(e) {
      if (!this.stop) {
        const feedTop = this.$refs?.feedRef?.getBoundingClientRect()?.top;
        const isShow = this.showTabBar;
        const changeShow = feedTop < 190;
        this.showTabBar = changeShow;
        if (changeShow && !this.feedListTop) {
          this.feedListTop = this.$refs?.feedList?.$el?.offsetTop || 0;
        }
        if (!isShow && changeShow) {
          this.showTab();
        }
        if (isShow && !changeShow) {
          this.hiddenTab();
        }
      }
    },
    computedCateId() {
      var currentSelectCateId = this.occupySubItemOfAll.cateId || this.cateId;
      var hasCateId = this.subItems.some(sub => sub.cateId === currentSelectCateId);
      if (hasCateId) {
        this.cateId = currentSelectCateId;
        this.occupySubItemOfAll = {};
      }
      // 外放
      if (!hasCateId) {
        if (this.subItems.length > 0 && this.subItems[0].cateId==='0') { // 从all中取
          this.subItems[0].subItems.items.forEach(subItem => {
            if (subItem.cateId === currentSelectCateId) {
              hasCateId = true;
              this.occupySubItemOfAll = subItem;
              currentSelectCateId = subItem.cateId;
            }
          });
        }
      }
      if (!hasCateId && this.subItems.length) {
        currentSelectCateId = this.subItems.filter(cat => cat.cateId !== '0')[0].cateId;
        this.occupySubItemOfAll = {};
        this.cateId = currentSelectCateId;
      }
    },
    async rankIndex(noComputeCategory) {
      this.feed = [];
      if (!this.init) {
        let currentTypes = this.types.filter(type => type.cateId === this.rankType);
        currentTypes = currentTypes.length <= 0 ? this.types : currentTypes;
        if (currentTypes.length > 0) {
          this.rankType = currentTypes[0].cateId;
          this.subItems = currentTypes[0].subItems.items;
          try {
            this.subItems.forEach((item, index) => {
              this.traceCateIdSw(item, index);
            })
          } catch(err) {}
          // 计算锚定cateid
          if (!noComputeCategory) { await this.computedCateId();}
        }
      }
      const params = {
        rankType: this.rankType,
        showVersion: this.showVersion,
        cateId: this.occupySubItemOfAll.cateId || this.cateId,
      }
      const res = await Api.rankIndex({ data: params });
      const { errno, traceId, data: { header, distributor, feed, noResult }} = res
      this.traceId = traceId;
      this.isLoading = false;
      this.isLoadingFeed = false;
      this.isNoResultFeed = noResult && !this.init;
      this.noResult = noResult?.compList[0].data;
      this.recId = res?.data?.recId;
      if (this.isNoResultFeed) return;
      // immutable rules map
      if (this.init) {
        this.isNoResult = noResult && !distributor;
        if (this.isNoResult) return;
        this.header = header?.data;
        this.rules = header?.data?.rules;
        header.data.rules[1].rankRules.forEach(r => {
          this.ruleMap[r.type] = r;
        });
        this.types = distributor?.compList[0].data?.items || [];
        try {
            this.types.forEach((item, index) => {
              this.traceTypeSw(item, index);
            })
          } catch(err) {}
        this.init = false;
        
        let currentTypes = this.types.filter(type => type.cateId === this.rankType);
        currentTypes = currentTypes.length <= 0 ? this.types : currentTypes;
        if (currentTypes.length > 0) {
          this.rankType = currentTypes[0].cateId;
          this.subItems = currentTypes[0].subItems.items;
          try {
            this.subItems.forEach((item, index) => {
              this.traceCateIdSw(item, index);
            })
          } catch(err) {}
          // 计算锚定cateid
          if (!noComputeCategory) {this.computedCateId();}
        }
        this.tracePageSw();
      }
      // immutable subItems
      
      // feed
      this.feed = feed?.compList;
      if (this.showTabBar) {
        let barH = this.$refs.tabBar.offsetHeight;
        this.$nextTick(() => {
          let top = 0
          if (this.newHeader) {
            top = this.feedListTop - barH
          } else {
            let height = this.scrollHeight < 250 ? 270 : this.scrollHeight - 50
            top = height ? height : 290
            if (this.types.length === 1 && this.subItems.length > 1) {
              top = top - 28
            }
          }
          window.scrollTo({
            top: top, //需要滚动的距离
          })
        })
      }
    }
  },
  beforeDestroy () {
    if (this.feedInterval) {
      clearInterval(this.feedInterval)
    }
  }
}
</script>
<style lang="scss" scoped>
.trending_list_page {
  position: relative;
  width: 100%;
  .back_icon {
    position: absolute;
    left: 46px;
    top: 88px;
    width: 18.97px;
    height: 33.99px;
  }
  .tab_bar {
    &.hidden {
      display: none;
    }
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    background: #F5F5F5;
    opacity: 1;
    .tab_title {
      position: relative;
      width: 100%;
      height: 43px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 88px;
      font-family: DiDiSans-Pro-Bold;
      font-size: 36px;
      color: #000000;
      letter-spacing: 0;
      font-weight: 700;
      svg {
        position: absolute;
        left: 46px;
        width: 18.97px;
        height: 33.99px;
      }
    }
    .tab_type {
      margin-top: 62px;
      height: 38px;
      display: flex;
      justify-content: center;
      .type_out_item {
        display: flex;
        .type_item {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;
          .type_name {
            font-family: DiDiSans-Pro-Medium;
            font-size: 28px;
            color: #975425;
            letter-spacing: 0;
            text-align: center;
            line-height: 28px;
            font-weight: 500;
            &.selected {
              font-family: DiDiSans-Pro-Bold;
              font-weight: 700;
            }
          }
          .type_bottom_line {
            margin-top: 6px;
            width: 123px;
            height: 6px;
            background: #975425;
            border-radius: 4px;
          }
        }
        .split {
          width: 32px;
          height: 39px;
        }
      }
      
    }
    .tab_type_1 {
      margin-top: 62px;
    }
    .tab_category {
      margin-top: 26px;
      margin-bottom: 32px;
    }
  }
 
  .type_container {
    // position: absolute;
    // top: 554px;
    margin-top: 72px;
    width: 100%;
    &.single {
      top: 538px;
    }
    .category_container {
      margin-top: 26px;
    }
    .feed_container_out {
      &.min_height {
        min-height: 1700px;
      }
      margin-top: -29px;
      padding-top: 61px;
      &.short_types {
        margin-top: 102px; // 子组件均上移50px
        padding-top: 0px;
      }
      background: linear-gradient(#E8E8E7,#E8E8E7); 
    }
    .new-header-item-only {
      position: relative;
      padding: 0 32px 0 48px;
      margin-bottom: 24px;
      line-height: 38px;
      font-size: 32px;
      font-family: DiDiSans-Pro-Bold;
      font-weight: 700;
      color: #975425;
      &:after {
        position: absolute;
        left: 32px;
        top: 5px;
        content: '';
        width: 4px;
        height: 28px;
        background: #975425;
        border-radius: 4px;
      }
    }
    &.hide-type {
      margin-top: 0;
      .category_container {
        margin-top: 0;
        margin-bottom: 32px;
      }
      .feed_container_out {
        margin-top: 0;
        padding-top: 0;
      }
    }
    &.new-header-style {
      .feed_container_out {
        background: transparent;
      }
    }
    
  }
}
.rules {
  position: absolute;
  top: 188px;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0,0,0,0.49);
  border-radius: 23px 0 0 23px;
  padding: 8px 12px 9px 24px;
  &.new-rules-style {
    top: 176px;
  }
  .name {
    font-family: DiDiSans-Pro-Regular;
    font-size: 24px;
    color: #FFFFFF;
    letter-spacing: 0;
    font-weight: 400;
  }
  .rules_img {
    width: 20px;
    height: 20px;
    margin-left: 4px;
  }
}
</style>